import './pt-logic-one-shot.css';
import { getModelFromInputAtPosition } from '../../common/getModelFunctions';

export default {
	model: {
		timeout: {
			default: null
		},
		active: {
			default: false
		},
		value: {
			default: false
		}
	},
	computed: {
		input_value() {
			const inputs = this.$el.dataset.inputs.split(',');

			return getModelFromInputAtPosition(this.$model, inputs, 0);
		}
	},
	watch: {
		input_value() {
			// this.$model is map with the diagram components IDs and its own data
			// FBE509FF-EE7C-482C-AF4B-5B428A444269: {
			//  "timeout": null,
			//  "active": false,
			//  "value": false,
			//  "input_value": false
			// }

			const logicComponent = this.$el;
			const logicComponentData = this.$model[logicComponent.id];

			handleInputValue(logicComponent, logicComponentData);
		}
	},
	listeners: {
		click: true
	}
};

export const DEFAULT_DURATION = 3000;

export function handleInputValue(logicComponent, logicComponentData) {
	const duration = parseInt(logicComponent.dataset.duration || DEFAULT_DURATION);

	if (!logicComponentData.input_value) return;

	if (logicComponentData.active) {
		clearTimeout(logicComponentData.timeout);
	}

	logicComponentData.active = true;
	logicComponentData.value = true;

	logicComponentData.timeout = setTimeout(function () {
		logicComponentData.active = false;
		logicComponentData.value = false;
	}, duration);
}
